






























































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { INSPECT_TYPE } from "@/model/InspectType";
import { Getter, Action } from "vuex-class";
import { SeibiItem } from "@/model/InspectionSeibi";
import requestService from "@/service/requestService";
import Number from "@/shared/filters/Number";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import { DO_TENKEN } from "@/model/DoTenken";
import { Utils } from "@/service/util";
import { MESSAGE } from "@/model/Message";
import { UserService } from "@/service/UserService";
import { IppanSeibiService } from "@/service/IppanSeibiService";
import { SocketControllers } from "@/service/SocketControllers";
import InputNumber from "@/components/common/input/InputNumber.vue";
import UserFooter from "@/components/UserFooter.vue";
import { EditPriceParam } from "@/model/EditPriceParam";
import TopBarTitle from "@/components/common/TopBarTitle.vue";
import { STATUS_SELECT_WORK_BUHIN } from "@/model/StatusSelectWorkBuhin";
import { ElButton } from "element-ui/types/button";
import ExtendsImageDialog from "@/components/ExtendsImageDialog.vue";
import { ExtendsImageService } from "@/service/ExtendsImageService";
import { ExtendsImageInspectVO } from "@/model/ExtendsImage";

@Component({
  filters: {
    Number
  },
  components: {
    ConfirmDialog,
    InputNumber,
    UserFooter,
    TopBarTitle,
    ExtendsImageDialog
  }
})
export default class InspectList extends Vue {
  isEditPrice: boolean = false;
  showAside: boolean = true;
  inspectType: number = INSPECT_TYPE.LEGAL56;
  reqService: requestService;
  ippanSeibiService: IppanSeibiService;
  sktControll: SocketControllers;
  indexTooltip: number = -1;
  listSeibi: SeibiItem[] = [];
  showPriceList: SeibiItem[] = [];
  totalPriceZn: number = 0;
  totalPriceZk: number = 0;
  isGoToRevNum: boolean = false;
  isSave: boolean = false;
  textTopTitle: string = "";
  textTopInfo: string = "";
  detailLinkPath: string = "";
  manualBuhinNm: string = "";
  manualBuhinKn: number | null = null;
  tmpDeleteWorkIndex: number = -1;
  sknUketsukeManualSeibiId: any = 0;
  $refs!: {
    confirmDialog: ConfirmDialog;
    confirmDialog2: ConfirmDialog;
    userFooter: UserFooter;
    askDeleteDialog: ConfirmDialog;
    buttonAddWork: ElButton;
    manualBuhinKn: InputNumber;
  };

  loadingText: string = MESSAGE.Loading;

  nextageFilter: number = 0; // 0:全部、1:法定のみ 2:法定以外
  // sideTabIndex: number = 0;
  routeName: string = "";
  nextConfirm: number = 0;

  extendsImageService: ExtendsImageService = new ExtendsImageService();
  extendsImageInspectMap: {[sknUketsukeInspectId: number]: ExtendsImageInspectVO} | null = null;
  extendsImageWorkList: ExtendsImageInspectVO[] | null = null;
  extendsImageWorkListIndex: number = -1;
  showExtendsImageDialog: boolean = false;
  
  isExitConnectSocket: boolean = false;

  public utils: Utils = new Utils();

  @Prop() onUserConfirmUpdating: boolean;

  @Action("setSeibiData", { namespace: "InspectSeibi" })
  setSeibiData: any;

  @Action("setListInspectId", { namespace: "InspectSeibi" })
  setListInspectId: any;

  @Action("editPrice", { namespace: "InspectSeibi" })
  editPrice: any;

  @Action("updateDotenken", { namespace: "InspectSeibi" })
  updateDotenken: any;

  @Action("updateDoTenken", { namespace: "InspectSeibiAK3" })
  updateDoTenkenAk3: any;

  @Action("updateDoTenkenFromSocket", { namespace: "InspectSeibi" })
  updateDoTenkenFromSocket: any;

  @Action("confirm", { namespace: "InspectSeibi" })
  confirm: any;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  @Getter("listInspectByType", { namespace: "InspectSeibi" })
  listInspect!: (inspectType: number) => SeibiItem[];

  @Getter("sumPriceByType", { namespace: "InspectSeibi" })
  sumPrice!: (inspectType: number) => any;

  @Getter("sumPriceByTypeForNextage", { namespace: "InspectSeibi" })
  sumPriceNex!: (inspectType: number, inspectId: number) => any;

  @Getter("hasData", { namespace: "InspectSeibi" })
  hasData: boolean;

  @Getter("getSeibiData", { namespace: "InspectSeibi" })
  seibiData: SeibiItem[][];
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;

  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;

  @Getter("seibiLoading", { namespace: "UserDataState" })
  isLoading: boolean;

  @Action("setSeibiData", { namespace: "InspectSeibiAK3" })
  setSeibiAK3Data: any;

  @Getter("isConfirmLegal56", { namespace: "InspectSeibi" })
  isConfirmLegal56: any;

  @Getter("isConfirmRecommend", { namespace: "InspectSeibi" })
  isConfirmRecommend: any;

  @Getter("isConfirm", { namespace: "Payment" })
  isConfirmPayment: any;

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;
  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  /** 2023-10-19 invoice [END] */

  /** 2023-12-01 jizen-mitsumori , sync sort-order [START] */
  @Getter("isCanJizenMitsumori", { namespace: "FunctionSetting" })
  isCanJizenMitsumori: any;
  /** 2023-12-01 jizen-mitsumori , sync sort-order [END] */

  @Getter("freeOfChargeLabelFull", { namespace: "FunctionSetting" })
  freeOfChargeLabel: any;

  @Getter("isCanExtendsImage", { namespace: "FunctionSetting" })
  isCanExtendsImage: any;

  /** 2023-05-01 sh #8240(BQR1090) add clearTimeout for notify. [START] */
  timeId: any = null;
  /** 2023-05-01 sh #8240(BQR1090) add clearTimeout for notify. [END] */

  @Watch("$route")
  onRouteChange(to: any, from: any) {
    this.setInspectType(to.name);
    this.$nextTick(() => {
      this.initPage();
    });
  }

  @Watch("seibiData")
  onSeibiDataChange(to: any, from: any) {
    this.setListSeibi();
    this.setIndexTooltip();
  }
  
  /** 2024-03-01 sh #8804(BQRxxx) 赤画面△の「する」「しない」選択操作をした際に 勝手に他部位の「する」「しない」が動く。 MFノースジャパン様 No.25 [START] */
  timerSave: any = null;
  /** 2024-03-01 sh #8804(BQRxxx) 赤画面△の「する」「しない」選択操作をした際に 勝手に他部位の「する」「しない」が動く。 MFノースジャパン様 No.25 [END] */

  /*
   * 初期化関数
   * ( createdやmountedで1回だけ実行される必要があるが
   *   特定のパラメータが足りない時は実行順序を前後させる必要がある処理 )
   */
  @Watch("uketsukeCd")
  connectSocket() {
    // 必要な値が未セット、または初期化済みなら何もしない
    if (!this.uketsukeCd || this.isExitConnectSocket) { return; }
    this.isExitConnectSocket = true;

    this.sktControll = new SocketControllers(this);
    this.sktControll.socketEntry("inspectSubscription",this.onInspectItemcompleted); // catchSocket:ソケット仮04
    this.sktControll.socketEntry("inspectSeibiSubscribe",this.onInspectcompleted); // catchSocket:ソケット仮06
    // catchSocket:13するしない後日編集
    this.sktControll.socketEntry("doTenkenSubscribe",this.onInspectionDotenken);

    // catchSocket:29車検項目の表示順並び替え
    this.sktControll.socketEntry("jizenDisplayOrderSubscription",this.onInspectionDotenken);
    this.sktControll.socketEntry("estimateListSubscription",this.onEditPrice); // catchSocket:ソケット仮01
    this.sktControll.connectSocket();
  }

  created() {
    this.reqService = new requestService();
    this.ippanSeibiService = new IppanSeibiService();
    this.connectSocket();
  }

  mounted() {
    if (this.$route.name) {
      this.setInspectType(this.$route.name);
      this.initPage();
    }
  }

  onClickEdit(isEdit: boolean) {
    this.listSeibi.forEach((item: any, index: number) => {
      if (item.kousuu < 0 && item.kouchinEditZk != this.showPriceList[index].kouchinEditZk) {
        if (!isEdit) {
          this.updatePrice();
        }
      }
    });
    this.isEditPrice = isEdit;
  }

  setListSeibi() {
    // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [START]
    this.reqService.checkJizenSort(this.uketsukeExtendsId).then((res: any) => {
      let isJizenSort = "true" === res.toString();
      let listSeibiCache: any;
      if (isJizenSort) {
        let seibi = JSON.parse(JSON.stringify(this.seibiData));
        if (seibi && seibi.length > 0) {
          let index = 0;
          if (this.inspectType === INSPECT_TYPE.RECOMMEND) { index = 4; }
          listSeibiCache = seibi[index];
        }
      } else {
      // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [END]
        listSeibiCache = this.listInspect(this.inspectType);
      // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [START]
      }

      if (listSeibiCache && this.nextageFilter != 0) {
        // ネクステージでは保安基準とそれ以外で別機能にする必要がある
        // 両方この機能で表示しているので表示モードに合わせて適切な方の内容をリストに残す
        if ( this.nextageFilter==1 ) {
          this.listSeibi = listSeibiCache.filter((item: any, index: number) => {
            // 保安基準で×のもの
            return item.isHoanKijun == 1 && item.inspectResult == 2;
          });
        } else {
          this.listSeibi = listSeibiCache.filter((item: any, index: number) => {
            // 保安基準以外か△ののもの
            return  item.isHoanKijun == 0 || item.inspectResult != 2;
          });
        }

      } else {
        this.listSeibi = listSeibiCache;
      }




// shakenHiyouKazeiItem = res.shakenHiyouItems.filter((item: any, index: number) => {
//            return index === res.shakenHiyouItems.findIndex((obj: any) => {
//              return item.shohiyouCd == obj.shohiyouCd && item.shohiyouNm == obj.shohiyouNm;
//            }) && item.shohiyouNm != '' && item.kazeiKbn == '1';
//          });


      // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [END]
      this.showPriceList = this.utils.deepCopy(this.listSeibi);

    // 工賃部品代のマイナス入力許可の為削除
    //  this.showPriceList.forEach((item: any) => {
    //    if (item.kouchinEditZk < 0) {
    //      item.kouchinEditZk = 0;
    //      item.kouchinEditZn = 0;
    //      item.kouchinZk = 0;
    //      item.kouchinZn = 0;
    //    }
    //  });

      let total: any;
      if (this.nextageFilter == 0) {
        total = this.sumPrice(this.inspectType);
      } else {
        total = this.sumPriceNex(this.inspectType,this.nextageFilter);
      }
      /** 2023-10-19 invoice [START] */
      this.totalPriceZn = total.totalZn;
      this.totalPriceZk = total.totalZk;
      /** 2023-10-19 invoice [END] */
    // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [START]
    });
    // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [END]
  }

  get isRecommend() {
    return this.inspectType == INSPECT_TYPE.RECOMMEND;
  }

  setInspectType(routeName: string) {
    if (routeName != 'estimate') {
      if (routeName == "userlegal56") {
        this.inspectType = INSPECT_TYPE.LEGAL56;
        // this.sideTabIndex = 2;
        this.routeName = routeName;
        this.nextageFilter = 0;
        this.textTopTitle = this.ippanSeibiService.isIppanSeibi ? '' : "法定57項目";
        this.textTopInfo = "検査の結果";
        this.detailLinkPath = "legal56workdetail";
      } else if (routeName == "userlegal56Nex1") {
        this.inspectType = INSPECT_TYPE.LEGAL56;
        // this.sideTabIndex = 6;
        this.routeName = routeName;
        this.nextageFilter = 1;
        this.textTopTitle = "車検不適合箇所";
        this.textTopInfo = "";
        this.detailLinkPath = "legal56Nex1workdetail";
      } else if (routeName == "userlegal56Nex2") {
        this.inspectType = INSPECT_TYPE.LEGAL56;
        // this.sideTabIndex = 7;
        this.routeName = routeName;
        this.nextageFilter = 2;
        this.textTopTitle = "安心整備";
        this.textTopInfo = "";
        this.detailLinkPath = "legal56Nex2workdetail";
      } else {
        this.inspectType = INSPECT_TYPE.RECOMMEND;
        // this.sideTabIndex = 3;
        this.routeName = routeName;
        this.textTopTitle = "おすすめ整備点検";
        this.textTopInfo = "の結果";
      }
    } else {
      this.textTopTitle = this.ippanSeibiService.isIppanSeibi ? '' : "現車・法定57項目"; // 工場側見積結果の編集モーダル等
      this.textTopInfo = "検査の結果";
      this.detailLinkPath = "workdetail";
    }
  }

  initPage() {
    // if (this.$route.name != 'estimate') {
    //  if (this.inspectType == INSPECT_TYPE.LEGAL56) {
    //    if (this.nextageFilter==1) {
    //      this.textTopTitle = "車検不適合箇所";
    //    } else if (this.nextageFilter==2) {
    //      this.textTopTitle = "安心整備";
    //    } else {
    //      this.textTopTitle = "法定57項目検査の結果";
    //    }
    //  } else {
    //    this.textTopTitle = "おすすめ整備点検の結果";
    //  }
    // } else {
    //  this.textTopTitle = "現車・法定57項目検査の結果"; // 工場側見積結果の編集モーダル等
    // }
    // let index;
    // if (this.inspectType == INSPECT_TYPE.LEGAL56) {
    //  index = 2;
    // } else {
    //  index = 3;
    // }
    if (window.sessionStorage.getItem("shaken:v2:user:seibi-edit-mode:" + this.inspectType)) {
      this.isEditPrice = true;
      window.sessionStorage.removeItem("shaken:v2:user:seibi-edit-mode:" + this.inspectType);
    } else {
      this.isEditPrice = false;
    }
    this.$emit("onActiveSideTab", this.routeName);
    this.getSeibi();
    this.getExtendsImageInspectMap();
  }

  getSeibi() {
    if (this.hasData) {
      this.setListSeibi();
      this.setIndexTooltip();
    } else if (!this.isLoading) {
      const userService = new UserService();
      userService.getAllData();
    }
  }

  setIndexTooltip() {
    // console.log("setIndexTooltip")
    if (this.inspectType == INSPECT_TYPE.LEGAL56) {
      if (this.listSeibi.length > 0) {
        let index = this.listSeibi.filter(
          (item: SeibiItem) => item.inspectResult == InspectButtonValue.CROSS
        ).length;
        if (this.listSeibi[index] && this.listSeibi[index].doTenken == 0) {
          this.indexTooltip = index;
        }
      }
    } else {
      this.indexTooltip = -1;
    }
  }

  isTriangle(item: SeibiItem) {
    if (this.inspectType == INSPECT_TYPE.LEGAL56) {
      return item.inspectResult == InspectButtonValue.TRIANGLE;
    }
    return false;
  }

  isCross(item: SeibiItem) {
    if (this.inspectType == INSPECT_TYPE.LEGAL56) {
      return item.inspectResult == InspectButtonValue.CROSS;
    }
    return false;
  }

  isMid(item: SeibiItem) {
    if (this.inspectType == INSPECT_TYPE.RECOMMEND || this.inspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
      return item.inspectResult == InspectButtonValue.TRIANGLE;
    }
    return false;
  }

  isHigh(item: SeibiItem) {
    if (this.inspectType == INSPECT_TYPE.RECOMMEND || this.inspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
      return item.inspectResult == InspectButtonValue.CROSS;
    }
    return false;
  }

  isLow(item: SeibiItem) {
    if (this.inspectType == INSPECT_TYPE.RECOMMEND || this.inspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
      return item.inspectResult == InspectButtonValue.CIRCLE;
    }
    return false;
  }

  isFree(item: SeibiItem) {
    if (this.inspectType == INSPECT_TYPE.RECOMMEND || this.inspectType == INSPECT_TYPE.RECOMMEND_MANUAL) {
      return item.inspectResult == InspectButtonValue.FREE;
    }
    return false;
  }

  isSuru(item: SeibiItem) {
    return (
      item.doTenken == DO_TENKEN.suru
      //  || item.inspectResult == InspectButtonValue.CROSS
    );
  }

  isShinai(item: SeibiItem) {
    return item.doTenken == DO_TENKEN.shinai;
  }

  isGojitsu(item: SeibiItem) {
    return item.doTenken == DO_TENKEN.gojitsu;
  }

  showTextStatus(item: SeibiItem) {
    if (this.isRecommend) {
      if (this.isMid(item)) {
        return "中";
      } else if (this.isHigh(item)) {
        return "高";
      } else if (this.isLow(item)) {
        return "低";
      } else {
        return "F";
      }
    }
    return "";
  }

  onCancelSavePrice() {
    if (this.isEditPrice) {
      this.showPriceList.map((data: any, index: number) => {
        data.kouchinEditZk = this.listSeibi[index].kouchinEditZk;
        data.buhinEditTotalZk = this.listSeibi[index].buhinEditTotalZk;
      });
      this.isEditPrice = false;
      if (this.isGoToRevNum) {
        this.$refs.userFooter.onSave();
      } else {
        setTimeout(() => {
          this.$refs.confirmDialog.onOpen();
        }, 200);
      }
    }
  }

  onConfirm() {
    if (this.isEditPrice) {
      this.$refs.confirmDialog2.onOpen();
    } else {
      this.$refs.confirmDialog.onOpen();
    }
  }

  nextPage() {

    // 57項目点検関連のチェックを優先
    this.nextConfirm = this.isConfirmLegal56; // デフォルトは現状維持
    let judgeFlag = false; // 変化が無ければAPI通信は不要
    if ( this.inspectType == INSPECT_TYPE.LEGAL56 ) {

      // 通常は未確認を確認にするだけでいい
      if ( this.isConfirmLegal56 === 0 ) {
        this.nextConfirm = 1;
        judgeFlag = true;
      }

      // ネクステージ限定の特殊動作を各個判断して設定上書き
      if ( this.routeName == "userlegal56Nex1" && this.isConfirmLegal56 == 0 ) { // 先に保安基準を確定した時
        this.nextConfirm = 2;
        judgeFlag = true;
      }
      if ( this.routeName == "userlegal56Nex2" && this.isConfirmLegal56 == 0 ) { // 先に安心整備を確定した時
        this.nextConfirm = 3;
        judgeFlag = true;
      }
      if ( ( this.routeName == "userlegal56Nex1" && this.isConfirmLegal56 == 3 ) ||
          ( this.routeName == "userlegal56Nex2" && this.isConfirmLegal56 == 2 ) ) { // 片方確定にしてからもう片方も確定した時
        this.nextConfirm = 1;
        judgeFlag = true;
      }
    }

    // 状態の更新(API通信)
    if (
      (this.inspectType == INSPECT_TYPE.LEGAL56 && judgeFlag ) ||
      (this.inspectType == INSPECT_TYPE.RECOMMEND && this.isConfirmRecommend === 0)
    ) {
      const isConfirmInspect =
        this.inspectType == INSPECT_TYPE.LEGAL56 ? this.nextConfirm : this.isConfirmLegal56;
      const isConfirmRecommend =
        this.inspectType == INSPECT_TYPE.RECOMMEND
          ? 1
          : this.isConfirmRecommend;
      const param = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        isConfirmInspect,
        isConfirmRecommend,
        isConfirmPayment: this.isConfirmPayment
      };
      this.reqService.saveIsConfirm(param).then(() => {
        this.processNextPage(); // 状態更新(store)を含む
      }, (error: any) => {
        this.$notify.info({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      });
    } else {
      this.processNextPage(); // 状態更新(store)を含む
    }
  }

  processNextPage() {
    this.$emit("onConfirmSideTab", this.routeName);
    let listRecommend = this.listInspect(INSPECT_TYPE.RECOMMEND);

    if (this.inspectType == INSPECT_TYPE.LEGAL56 && this.routeName == "userlegal56Nex1") {
      this.confirm({ type: this.inspectType, value: this.nextConfirm });
      this.$emit("onUserConfirm");
      this.$router.push({ name: "requiredetail" });
    } else if (this.inspectType == INSPECT_TYPE.LEGAL56 && this.routeName == "userlegal56Nex2") {
      this.confirm({ type: this.inspectType, value: this.nextConfirm });
      this.$emit("onUserConfirm");
      this.$router.push({ name: "soukouhosho" });
    } else if (this.inspectType == INSPECT_TYPE.LEGAL56 && listRecommend.length > 0) {
      this.confirm({ type: this.inspectType, value: 1 });
      this.$emit("onUserConfirm");
      this.$router.push({ name: "userrecommend" });
    } else {
      this.confirm({ type: this.inspectType, value: 1 });
      this.$emit("onUserConfirm");
      this.$router.push({ name: "paymentdetail" });
    }
  }

  nextPage2() {
    if (this.isEditPrice) {
      this.updatePrice();
      this.$emit("update:isEditPrice", false);
      if (this.isGoToRevNum) {
        this.$refs.userFooter.onSave();
      } else {
        setTimeout(() => {
          this.$refs.confirmDialog.onOpen();
        }, 200);
      }
    }
  }

  updatePrice() {// 金額変更
    this.listSeibi.map((data: SeibiItem, index: number) => {
      let newdata: any = {};
      newdata.kouchinZk = this.showPriceList[index].kouchinEditZk;
      newdata.buhinZk = this.showPriceList[index].buhinEditTotalZk;
      newdata.kouchinZn = this.showPriceList[index].kouchinEditZn;
      newdata.buhinZn = this.showPriceList[index].buhinEditTotalZn;
      if (this.isExcludingTax) {
        this.reqUpdatePriceSetData(data,index,newdata,2); // 税抜
      } else {
        this.reqUpdatePriceSetData(data,index,newdata,1); // 税込
      }
    });
  }

  // 金額変更による更新の必要性を確認して反映
  reqUpdatePriceSetData(seibi: SeibiItem, index: number,data: any,type: number) {
    let paramUpdate = {} as EditPriceParam;
    paramUpdate.sknUketsukeExtendsId = this.uketsukeExtendsId;
    let doUpdate = false;// 更新実行可否

    // 税込
    if ( type == 1 && ( seibi.kouchinEditZk != data.kouchinZk || seibi.buhinEditTotalZk != data.buhinZk ) ) {
      seibi.kouchinEditZk = data.kouchinZk;
      seibi.buhinEditTotalZk = data.buhinZk;
      paramUpdate.kouchinEditZk = data.kouchinZk  == seibi.kouchinZk ? null : data.kouchinZk || 0;
      paramUpdate.buhinEditTotalZk = data.buhinZk == seibi.buhinZk ? null : data.buhinZk || 0;
      doUpdate = true;
    }

    // 税抜
    if ( type == 2 && ( seibi.kouchinEditZn != data.kouchinZn || seibi.buhinEditTotalZn != data.buhinZn ) ) {
      seibi.kouchinEditZn = data.kouchinZn;
      seibi.buhinEditTotalZn = data.buhinZn;
      paramUpdate.kouchinEditZn = data.kouchinZn  == seibi.kouchinZn ? null : data.kouchinZn || 0;
      paramUpdate.buhinEditTotalZn = data.buhinZn == seibi.buhinZn ? null : data.buhinZn || 0;
      doUpdate = true;
    }

    if ( doUpdate ) {
      this.updateDotenken(seibi);

      if (seibi.sknUketsukeManualSeibiId) {
        paramUpdate.sknUketsukeInspectSeibiManualId = seibi.sknUketsukeManualSeibiId;
      } else {
        paramUpdate.sknUketsukeInspectSeibiId = seibi.sknInspectSeibiId;
      }
      /** 2021-05-27 sh #7123 if change price, change the flag. [START] */
      if (this.inspectType == INSPECT_TYPE.RECOMMEND && this.isConfirmRecommend) {
        this.saveIsConfirmRecommend();
      }
      if (this.inspectType == INSPECT_TYPE.LEGAL56 && this.isConfirmLegal56) {
        this.saveIsConfirmInspect();
      }

      // 税込み編集限定：事前見積もりONの時の手入力の構造違いにより金額更新の構造も変化する
      if (type == 1 && this.inspectType == INSPECT_TYPE.RECOMMEND 
        && seibi.inspectResult == INSPECT_TYPE.RECOMMEND_MANUAL
      ) {
        this.reqService.checkJizenSort(this.uketsukeExtendsId).then((res: any) => {
          let isJizenSort = "true" === res.toString();
          if (isJizenSort) {
            const body: any = {
              sknUketsukeExtendsId : seibi.sknUketsukeExtendsId,
              sknUketsukeInspectSeibiId : null,
              sknUketsukeInspectSeibiManualId : seibi.sknUketsukeManualSeibiId,
              buhinEditTotalZk : data.buhinZk,
              buhinEditTotalZn : data.buhinZn,
              kouchinEditZk : data.kouchinZk, 
              kouchinEditZn : data.kouchinZn
            };
            this.editPrice(body);
            // this.setSeibiData(this.listSeibi);
          }
        });
      }
      
      this.reqUpdatePrice(paramUpdate);
    }
  }

  // 小計更新
  reqUpdatePrice(paramUpdate: any) {
    this.isSave = true;
    this.reqService.updatePrice(paramUpdate); // sendSocket:ソケット仮01
    /** 2023-10-19 invoice [START] */
    this.totalPriceZn = this.sumPrice(this.inspectType).totalZn;
    this.totalPriceZk = this.sumPrice(this.inspectType).totalZk;
    /** 2023-10-19 invoice [END] */
    // let page = this.inspectType == INSPECT_TYPE.LEGAL56 ? 2 : 3;
    this.$emit("onUpdateSideTab", this.routeName);
  }

  clickDoTenken(
    item: SeibiItem,
    doTenken: number,
    index: number,
    isAll: boolean = false
  ) {
    let flg = true;
    if (!isAll && this.inspectType ==2 && item.rowNum == 0 && doTenken == 1) {
      this.listSeibi.forEach((seibi: any) => {
        if (seibi.sknInspectDescriptionSeibiId == 0 && seibi.doTenken != 1) {
          flg = false;
        }
      });
    }
    if (flg) {
      if (item.doTenken == doTenken) {
        return;
      }
      if (item.inspectResult != InspectButtonValue.CROSS) {
        this.indexTooltip = -1;
      }
      item.doTenken = doTenken;
      if (this.isEditPrice && index >= 0 && doTenken != 1) {
        this.showPriceList[index].kouchinEditZk = this.listSeibi[
          index
        ].kouchinEditZk;
        this.showPriceList[index].buhinEditTotalZk = this.listSeibi[
          index
        ].buhinEditTotalZk;
      }
      this.updateDotenken(item);
      this.totalPriceZn = this.sumPrice(this.inspectType).totalZn;
      this.totalPriceZk = this.sumPrice(this.inspectType).totalZk;
      this.$emit("onUpdateSideTab", this.routeName);

      if (!isAll) {
        this.updateDoTenkenCallApi(item, doTenken);
      }
    } else {
      if (item.sknInspectType == INSPECT_TYPE.USER_MANUAL) {
        this.updateDoTenkenCallApi(item, doTenken);
      }
      if (this.inspectType == INSPECT_TYPE.RECOMMEND && this.isConfirmRecommend) {
        this.saveIsConfirmRecommend();
      }
    }
  }

  updateDoTenkenCallApi(
    item: any
    , doTenken: number
  ) {
    const promiseAll: any = [];
    if (this.timerSave) {
      clearTimeout(this.timerSave);
      this.timerSave = null;
    }

    if (item.sknUketsukeManualSeibiId != null) {
      const pSub2 = this.updateDoTenkenPM(
        this.uketsukeExtendsId
        , doTenken
        , item.sknInspectId
        , null
        , item.sknUketsukeManualSeibiId
      );
      promiseAll.push(pSub2);
    } else {
      // 手入力作業以外
      const pMain = this.updateDoTenkenPM(
        this.uketsukeExtendsId
        , doTenken
        , item.sknInspectId
        , item.sknInspectSeibiId
        , null
      );
      promiseAll.push(pMain);
    }

    // お奨めはitemではなくseibi単位で更新する
    if (this.inspectType ==INSPECT_TYPE.RECOMMEND  && item.sknInspectDescriptionSeibiId == 0) {
      this.listSeibi.forEach((seibi: any, i: number) => {
        if (seibi.rowNum == 0 && item.sknRecommendInspectCategoryId == seibi.sknRecommendInspectCategoryId
          && seibi.sknInspectDescriptionSeibiId != item.sknInspectDescriptionSeibiId) {
          const pSub = this.updateDoTenkenPM(
            this.uketsukeExtendsId
            , doTenken
            , seibi.sknInspectId
            , seibi.sknUketsukeManualSeibiId != null ? null : seibi.sknInspectSeibiId
            , seibi.sknUketsukeManualSeibiId
          );
          promiseAll.push(pSub);
          this.clickDoTenken(seibi,doTenken,i, true);
        }
      });
    }

    Promise.all(promiseAll).then((retList: any) => {
      this.timerSave = setTimeout(() => {
        const userService = new UserService();
        userService.autoSaveAk7(); // sendSocket:ソケット仮34
      }, 2000);
    }, ((err: any) => {
      this.$notify.error({
        title: "エラー",
        message: MESSAGE.SystemError
      });
    }));
  }

  updateDoTenkenPM(uketsukeExtendsId: any
  , doTenken: any
  , sknInspectId: any
  , sknInspectSeibiId: any
  , sknUketsukeManualSeibiId: any
  ) {
    const promise = new Promise((resolve: any, reject: any) => {
      this.reqService.updateDoTenken( // sendSocket:02作業指示の編集（するしない後日および部品代） // sendSocket:13するしない後日編集
        uketsukeExtendsId,
        doTenken,
        sknInspectId,
        sknInspectSeibiId,
        sknUketsukeManualSeibiId
      ).then((res: any) => {
        resolve(res);
      }, (error: any) => {
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
        reject();
      });
    });
    return promise;
  }
  /** 2023-03-28 sh #8188(BQR1084) course does not work for recommend. [END] */

  closeTooltip() {
    this.indexTooltip = -1;
  }

  gotoCustomer() {
    this.$router.push({
      name: "usercustomer",
      params: { code: this.yoyakuNo }
    });
  }

  // ユーザー画面以外では使っている可能性が残っている
  onInspectItemcompleted(frame: any) {
    const body = this.utils.getWSData(frame);
    const seibi = { ...body };
    delete seibi.sknWorkProgressState;
    delete seibi.sknWorkProgressStateNm;
    this.setSeibiAK3Data(seibi);
  }

  // ユーザー画面以外では使っている可能性が残っている
  onInspectcompleted(frame: any) {
    const body = this.utils.getWSData(frame);
    const seibi = { ...body };
    delete seibi.items.sknWorkProgressState;
    delete seibi.items.sknWorkProgressStateNm;
  this.setSeibiData(seibi); // inspectSeibiStoreデータセット
    this.setListInspectId(this.listInspect(1));
    // this.setListSeibi();
    this.notify();
  }

  onInspectionDotenken(frame: any) {
    // const body = this.utils.getWSData(frame);
    // this.updateDoTenkenFromSocket(body);
    // this.setListSeibi();
    // this.$forceUpdate();
    if (this.inspectType == INSPECT_TYPE.LEGAL56) {
      const userService = new UserService();
      userService.getSeibi();
      // 整備対象リスト用意(ユーザー側)
      userService.getSeibiAK3();
    }
    if (this.isSave) {
      this.isSave = false;
    } else {
      this.notify();
    }
  }

  notify() {
    /** 2023-05-01 sh #8240(BQR1090) add clearTimeout for notify. [START] */
    // this.$notify.info({
    //  title: "Info",
    //  message: MESSAGE.UpdatedInspections
    // });
    clearTimeout(this.timeId);
    this.timeId = setTimeout(() => {
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedInspections
      });
    }, 1500);
    /** 2023-05-01 sh #8240(BQR1090) add clearTimeout for notify. [END] */
  }

  gotoDetail(item: any) {
    // if (item.sknInspectId) {
    //   this.$router.push({
    //     name: "workdetail",
    //     query: { q: `inspect=${item.sknInspectId.toString()}` }
    //   });
    // } else if (item.sknInspectSeibiId) {
    //   this.$router.push({
    //     name: "workdetail",
    //     query: { q: `seibi=${item.sknInspectSeibiId.toString()}` }
    //   });
    // }
    if (item.sknInspectId) {
      this.$router.push({
        name: this.detailLinkPath.toString(),
        query: { inspect: item.sknInspectId.toString() }
        // query: {
        //  inspect: item.sknInspectId.toString(),
        //  index: "0"
        // }
      });
    } else if (item.sknInspectSeibiId) {
      this.$router.push({
        name: this.detailLinkPath.toString(),
        query: { seibi: item.sknInspectSeibiId.toString() }
        // query: {
        //  seibi: item.sknInspectSeibiId.toString(),
        //  index: "0"
        // }
      });
    }
  }

  onConfirmGotoRevNum() {
    if (this.isEditPrice) {
      this.isGoToRevNum = true;
      this.$refs.confirmDialog2.onOpen();
    } else {
      this.$refs.userFooter.onSave();
    }
  }

  onEditPrice(frame: any) {
    const body = this.utils.getWSData(frame);
    this.editPrice(body);
    this.setListSeibi();
    // let page = this.inspectType == INSPECT_TYPE.LEGAL56 ? 2 : 3;
    this.$emit("onUpdateSideTab", this.routeName);
    if (this.isSave) {
      this.isSave = false;
    } else {
      this.notify();
    }
  }

  beforeDestroy() {
    if (this.isEditPrice) {
      window.sessionStorage.setItem("shaken:v2:user:seibi-edit-mode:" + this.inspectType, "1");
    } else {
      window.sessionStorage.removeItem("shaken:v2:user:seibi-edit-mode:" + this.inspectType);
    }
  }

  saveManualAk5(data: any) {
    this.reqService.saveManualAk5(data).then((res: any) => { // sendSocket:ソケット仮06
    }, (error: any) => {
      this.$notify.info({
        title: "エラー",
        message: MESSAGE.SystemError
      });
    });
  }

  addWork() {
    if (this.manualBuhinNm) {
      /** 2023-10-19 invoice [START] */
      let manualSeibiList: any = [];
      if (this.isExcludingTax) {
        manualSeibiList = [{
          seibiNm: this.manualBuhinNm,
          buhinZn: this.manualBuhinKn,
          buhinEditTotalZn: this.manualBuhinKn,
          buhinSelected: STATUS_SELECT_WORK_BUHIN.FakeDone,
          kousuu: 0,
          manualBuhinList: []
        }];
        // manualSeibiList["buhinZn"] = this.manualBuhinKn;
        // manualSeibiList["buhinEditTotalZn"] = this.manualBuhinKn;
      } else {
        manualSeibiList = [{
        seibiNm: this.manualBuhinNm,
          buhinZk: this.manualBuhinKn,
          buhinEditTotalZk: this.manualBuhinKn,
          buhinSelected: STATUS_SELECT_WORK_BUHIN.FakeDone,
          kousuu: 0,
          manualBuhinList: []
        }];
        // manualSeibiList["buhinZk"] = this.manualBuhinKn;
        // manualSeibiList["buhinEditTotalZk"] = this.manualBuhinKn;
      }
      /** 2023-10-19 invoice [END] */
      const data: any = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        sknInspectType: INSPECT_TYPE.USER_MANUAL,
        // 赤からおすすめ作業を手入力したときの"するしない"制御
        doTenken: DO_TENKEN.suru,
        manualSeibiList: manualSeibiList
      };
      this.saveManualAk5(data);
      this.manualBuhinNm = "";
      /** 2023-10-19 invoice [START] */
      this.manualBuhinKn = null;
      /** 2023-10-19 invoice [END] */
    }
  }

  removeWork(e: any, index: number) {
    e.stopPropagation();
    this.tmpDeleteWorkIndex = index;
    this.sknUketsukeManualSeibiId = this.listSeibi[index].sknUketsukeManualSeibiId || 0;
    this.$refs.askDeleteDialog.onOpen();
  }

  onConfirmDelete() {
    const data: any = {
      uketsukeExtendsId: this.uketsukeExtendsId,
      sknUketsukeManualSeibiId: this.sknUketsukeManualSeibiId
    };
    this.reqService.deleteUketsukeManualSeibi(data).then( // sendSocket:ソケット仮06
      (response: any) => {
        this.listSeibi.splice(this.tmpDeleteWorkIndex, 1);
      },
      (err: any) => {
        // console.log(err);
      }
    );
  }

  changeEditMode(e: any, work: any) {
    e.stopPropagation();
    if (work.editMode) {
      work.editMode = false;
    } else {
      work.editMode = true;
    }
    this.$forceUpdate();
  }

  changeManual(item: any) {
    const manualSeibiList: any = [{
      seibiId: item.sknUketsukeManualSeibiId || 0,
      seibiNm: item.sknInspectSeibiDescriptionNm
    }];
    const data: any = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      manualSeibiList: manualSeibiList
    };
    this.reqService.updateUketsukeManualSeibi(data).then((res: any) => { // sendSocket:ソケット仮06
      item.editMode = false;
      this.$forceUpdate();
    }, (error: any) => {
      this.$notify.info({
        title: "エラー",
        message: MESSAGE.SystemError
      });
    });
  }

  onEnterManualBuhinNm(event: any) {
    setTimeout(() => {
      if (event.target) {
        event.target.blur();
      }
      this.$refs.buttonAddWork.$el.focus();
    });
  }

  onEnterManualBuhinZk() {
    this.$refs.buttonAddWork.$el.focus();
  }

  /** 2021-05-27 sh #7123 it does not re-calculate, if edit price of seibi or buhin. [START] */
  itemTotalZk(seibi: SeibiItem) {
    let buhinEditTotalZk = seibi.buhinEditTotalZk;
    let kouchinEditZk = seibi.kouchinEditZk;
    if (seibi.buhinEditTotalZk === null) {
      buhinEditTotalZk = seibi.buhinZk;
    }
    if (seibi.kouchinEditZk === null) {
      kouchinEditZk = seibi.kouchinZk;
    }
    return (buhinEditTotalZk == null ? 0 : buhinEditTotalZk) + (kouchinEditZk == null ? 0 : kouchinEditZk);
  }
  /** 2021-05-27 sh #7123 it does not re-calculate, if edit price of seibi or buhin. [END] */

  /** 2023-10-19 invoice [START] */
  itemTotalZn(seibi: SeibiItem) {
    let buhinEditTotalZn = seibi.buhinEditTotalZn;
    let kouchinEditZn = seibi.kouchinEditZn;
    if (seibi.buhinEditTotalZn === null) {
      buhinEditTotalZn = seibi.buhinZn;
    }
    if (seibi.kouchinEditZn === null) {
      kouchinEditZn = seibi.kouchinZn;
    }
    return (buhinEditTotalZn == null ? 0 : buhinEditTotalZn) + (kouchinEditZn == null ? 0 : kouchinEditZn);
  }
  /** 2023-10-19 invoice [END] */
  /** 2021-05-27 sh #7123 if change price, change the flag. [START] */
  saveIsConfirmRecommend() {
    if (this.inspectType == INSPECT_TYPE.RECOMMEND && this.isConfirmRecommend) {
      let paramConfirmSend: any = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        isConfirmRecommend: 0,
      };
      this.reqService.saveIsConfirmRecommend(paramConfirmSend).then(() => {
        // this.confirm({ type: this.inspectType, value: 0 }); // サーバ側を更新した後、同期するので、不要なはず。
        this.$emit("onUserConfirmSync");
      }, (error: any) => {
        this.$notify.info({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      });
    }
  }
  saveIsConfirmInspect() {
    if (this.inspectType == INSPECT_TYPE.LEGAL56 && this.isConfirmLegal56) {
      let paramConfirmSend: any = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        isConfirmInspect: 0,
      };
      this.reqService.saveIsConfirmInspect(paramConfirmSend).then(() => {
        this.$emit("onUserConfirmSync");
      }, (error: any) => {
        this.$notify.info({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      });
    }
  }
  // 呼び出し元が見つからない
  // saveIsConfirm() {// 
  //  if (
  //    (this.inspectType == INSPECT_TYPE.LEGAL56 && this.isConfirmLegal56 === 0) ||
  //    (this.inspectType == INSPECT_TYPE.RECOMMEND && this.isConfirmRecommend === 0)
  //  ) {
  //    const isConfirmInspect =
  //      this.inspectType == INSPECT_TYPE.LEGAL56 ? 1 : this.isConfirmLegal56;
  //    const isConfirmRecommend =
  //      this.inspectType == INSPECT_TYPE.RECOMMEND
  //        ? 1
  //        : this.isConfirmRecommend;
  //    const param = {
  //      sknUketsukeExtendsId: this.uketsukeExtendsId,
  //      isConfirmInspect,
  //      isConfirmRecommend,
  //      isConfirmPayment: this.isConfirmPayment
  //    };
  //    this.reqService.saveIsConfirm(param).then(() => {
  //      // this.confirm({ type: this.inspectType, value: 1 }); // サーバ側を更新した後、同期するので、不要なはず。
  //      this.$emit("onUserConfirmSync");
  //    }, (error: any) => {
  //      this.$notify.info({
  //        title: "エラー",
  //        message: MESSAGE.SystemError
  //      });
  //    });
  //  }
  // }
  /** 2021-05-27 sh #7123 if change price, change the flag. [END] */

  /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [START] */
  hasMultipleBuhin(item: any) {
    if (item && item.hasOwnProperty("isHasMultipleBuhin") && item.isHasMultipleBuhin == 1) {
      return "";
    }
    return "d_ni";
  }
  /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [END] */

  async getExtendsImageInspectMap() {
    if (!this.isCanExtendsImage) {
      return;
    }
    this.extendsImageInspectMap = await this.extendsImageService.getExtendsImageInspectMap();
    this.extendsImageService.connectSocket(this.extendsImageSocketCallback, this.sktControll);
  }
  extendsImageSocketCallback(updatedList: ExtendsImageInspectVO[]) {
    if (updatedList[0].carImageMenuId) {
      return;
    }
    this.$message({
      message: MESSAGE.UpdatedImage,
      type: "info",
      duration: 700,
      customClass: "msg-center shadow",
      showClose: true
    });
    if (!this.extendsImageInspectMap) {
      this.extendsImageInspectMap = {};
    }
    this.extendsImageInspectMap[updatedList[0].sknUketsukeInspectId!] = updatedList[0];
    this.updateExtendsImageWorkList();
  }
  hasImage(item: SeibiItem): boolean {
    return !!(
      this.isCanExtendsImage &&
      this.extendsImageInspectMap &&
      this.extendsImageInspectMap[item.sknInspectId] &&
      this.extendsImageInspectMap[item.sknInspectId].imageList &&
      this.extendsImageInspectMap[item.sknInspectId].imageList!.length > 0
    );
  }
  updateExtendsImageWorkList(sknInspectSeibiId: any = null, sknUketsukeManualSeibiId: any = null) {
    this.extendsImageWorkList = [];
    if (!this.extendsImageInspectMap) {
      return;
    }
    for (const item of this.listSeibi) {
      if (!this.hasImage(item)) {
        continue;
      }
      const work = this.utils.deepCopy(this.extendsImageInspectMap[item.sknInspectId]);
      work.label += `(${item.sknInspectSeibiDescriptionNm})`;
      this.extendsImageWorkList.push(work);
      if ((sknInspectSeibiId && sknInspectSeibiId == item.sknInspectSeibiId)
        || (sknUketsukeManualSeibiId && sknUketsukeManualSeibiId == item.sknUketsukeManualSeibiId)) {
        this.extendsImageWorkListIndex = this.extendsImageWorkList.length - 1;
      }
    }
  }
  openExtendsImageDialog(item: any) {
    if (!this.extendsImageInspectMap) {
      this.$notify.error({
        title: "エラー",
        message: MESSAGE.SystemError
      });
      window.console.error('openExtendsImageDialog: extendsImageInspectMapが空');
      return;
    }
    this.updateExtendsImageWorkList(item.sknInspectSeibiId, item.sknUketsukeManualSeibiId);
    this.showExtendsImageDialog = true;
  }
}
